import React, { useCallback } from 'react';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { Button } from 'app/shared/components';
import { useSurveyConfig } from 'app/core/survey-config';
import { useStyles } from './styles';

export default function Start() {
  const engine = useEngineInstance();
  const onClick = useCallback(() => engine.goNextPage(), [engine]);
  const { wording } = useSurveyConfig();
  const styles = useStyles();

  return (
    <div className={styles.startContainer}>
      <Button className={styles.start} color="primary" onClick={onClick}>
        {wording.common.action.begin}
      </Button>
    </div>
  );
}
